import {
  IEventGroupActionTypes,
  IEventGroupType,
  IEventGroupActionCreator,
} from "models/IEventState";

const initialState: IEventGroupType = {};

const reducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case IEventGroupActionTypes.FETCH_EVENT_GROUPS_REQUEST:
      return {
        ...state,
        groups_data: [],
      };
    case IEventGroupActionTypes.FETCH_EVENT_GROUPS_SUCCESS:
      return {
        ...state,
        groups_data: [...payload.data],
      };

    case IEventGroupActionTypes.FETCH_EVENT_VENUES_REQUEST:
      return {
        ...state,
        venues_data: [],
      };
    case IEventGroupActionTypes.FETCH_EVENT_VENUES_SUCCESS:
      return {
        ...state,
        venues_data: [...payload.data],
      };

    case IEventGroupActionTypes.FETCH_EVENT_TYPES_REQUEST:
      return {
        ...state,
        types_data: [],
      };
    case IEventGroupActionTypes.FETCH_EVENT_TYPES_SUCCESS:
      return {
        ...state,
        types_data: [...payload.data],
      };

    case IEventGroupActionTypes.FETCH_HOLIDAYS_REQUEST:
      return {
        ...state,
        holidays_data: [],
      };
    case IEventGroupActionTypes.FETCH_HOLIDAYS_SUCCESS:
      return {
        ...state,
        holidays_data: [...payload.data],
      };

    case IEventGroupActionTypes.FETCH_GROUP_MEMBERS_REQUEST:
      return {
        ...state,
        group_members_data: [],
      };
    case IEventGroupActionTypes.FETCH_GROUP_MEMBERS_SUCCESS:
      return {
        ...state,
        group_members_data: !!payload.data ? [...payload.data] : [],
      };

    case IEventGroupActionTypes.FETCH_MASTER_PROJECTS_REQUEST:
      return {
        ...state,
        master_projects_data: [],
      };
    case IEventGroupActionTypes.FETCH_MASTER_PROJECTS_SUCCESS:
      return {
        ...state,
        master_projects_data: !!payload.data ? [...payload.data] : [],
      };

    case IEventGroupActionTypes.FETCH_MASTER_SUB_PROJECTS_REQUEST:
      return {
        ...state,
        master_sub_projects_data: [],
      };
    case IEventGroupActionTypes.FETCH_MASTER_SUB_PROJECTS_SUCCESS:
      return {
        ...state,
        master_sub_projects_data: !!payload.data ? [...payload.data] : [],
      };

    case IEventGroupActionTypes.FETCH_MASTER_PROJECT_DETAILS_REQUEST:
      return {
        ...state,
        master_project_details_data: [],
      };
    case IEventGroupActionTypes.FETCH_MASTER_PROJECT_DETAILS_SUCCESS:
      return {
        ...state,
        master_project_details_data: !!payload.data ? { ...payload.data } : [],
      };

    case IEventGroupActionTypes.FETCH_MASTER_SUB_PROJECT_DETAILS_REQUEST:
      return {
        ...state,
        master_sub_project_details_data: {},
      };
    case IEventGroupActionTypes.FETCH_MASTER_SUB_PROJECT_DETAILS_SUCCESS:
      return {
        ...state,
        master_sub_project_details_data: !!payload.data
          ? { ...payload.data }
          : {},
      };

    case IEventGroupActionTypes.FETCH_MASTER_TEAMS_REQUEST:
      return {
        ...state,
        master_teams_data: [],
      };

    case IEventGroupActionTypes.FETCH_MASTER_TEAMS_SUCCESS:
      return {
        ...state,
        master_teams_data: !!payload.data ? [...payload.data] : [],
      };

    case IEventGroupActionTypes.FETCH_MASTER_SUB_TEAMS_REQUEST:
      return {
        ...state,
        master_sub_teams_data: [],
      };

    case IEventGroupActionTypes.FETCH_MASTER_SUB_TEAMS_SUCCESS:
      return {
        ...state,
        master_sub_teams_data: !!payload.data ? [...payload.data] : [],
      };

    case IEventGroupActionTypes.FETCH_MASTER_TEAM_DETAILS_REQUEST:
      return {
        ...state,
        master_team_details_data: [],
      };

    case IEventGroupActionTypes.FETCH_MASTER_TEAM_DETAILS_SUCCESS:
      return {
        ...state,
        master_team_details_data: !!payload.data ? { ...payload.data } : [],
      };

    case IEventGroupActionTypes.FETCH_CUSTOMERS_LIST_REQUEST:
      return {
        ...state,
        customers_list_data: [],
      };

    case IEventGroupActionTypes.FETCH_CUSTOMERS_LIST_SUCCESS:
      return {
        ...state,
        customers_list_data: !!payload.data ? [...payload.data] : [],
      };

    case IEventGroupActionTypes.FETCH_TAGS_LIST_REQUEST:
      return {
        ...state,
        tags_list_data: [],
      };

    case IEventGroupActionTypes.FETCH_TAGS_LIST_SUCCESS:
      return {
        ...state,
        tags_list_data: !!payload.data ? [...payload.data] : [],
      };

    case IEventGroupActionTypes.FETCH_SCHEDULED_EMPLOYEES_REQUEST:
      return {
        ...state,
        scheduled_employees_list: [],
      };

    case IEventGroupActionTypes.FETCH_SCHEDULED_EMPLOYEES_SUCCESS:
      return {
        ...state,
        scheduled_employees_list: !!payload ? [...payload] : [],
      };

    case IEventGroupActionTypes.FETCH_SCHEDULED_EVENT_EMPLOYEES_REQUEST:
      return {
        ...state,
        scheduled_event_employees_list: [],
      };

    case IEventGroupActionTypes.FETCH_SCHEDULED_EVENT_EMPLOYEES_SUCCESS:
      return {
        ...state,
        scheduled_event_employees_list: !!payload ? [...payload] : [],
      };

    
    case IEventGroupActionTypes.FETCH_USER_TYPES_REQUEST:
      return {
        ...state,
        user_types: [],
      };

    case IEventGroupActionTypes.FETCH_USER_TYPES_SUCCESS:
      return {
        ...state,
        user_types: payload?.data?.length ? [...payload.data] : [],
      };

    default:
      return state;
  }
};

export default reducer;
